<template>
  <Layout>
    <div class="banner-page">
      <img :src="'/img/program-banner.jpg'" alt="Image" />
    </div>

    <div class="breadcrumbs">
      <div class="container">
        <ul>
          <li>
            <router-link :to="`/`">Beranda</router-link>
          </li>
          <li>
            <router-link :to="`/program`">Program</router-link>
          </li>
          <li>Donasi Masjid</li>
          <li>
            <span>Status Pembayaran</span>
          </li>
        </ul>
      </div>
    </div>

    <section class="page-section pembayaran">
      <div class="container">
        <div class="main-content bg-white">
          <div class="main-content bg-white pad-36">
            <form
              class="standar-form payment-after-action"
              action="javascript:void(0)"
            >
              <!-- method label -->

              <h4>Status Pembayaran</h4>
              <div class="spacer"></div>

              <div class="nominal-label">
                <div class="loading-overlay" v-if="isLoading">
                  <div class="mohontunggu">
                    <p class="mohontunggu-text">Mohon menunggu,</p>
                    <p class="diproses-text">Sedang Diproses...</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="text">ID Transaksi</div>
                  </div>
                  <div class="col-md-12">
                    <div>
                      {{ statusData.no_transaksi || '' }}
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="text">Tanggal Transaksi</div>
                  </div>
                  <div class="col-md-12">
                    <div>{{ statusData.tgl_transaksi }}</div>
                  </div>

                  <div class="col-md-12">
                    <div class="text">Nama Donatur</div>
                  </div>
                  <div class="col-md-12">
                    <div>{{ statusData.namaDonatur }}</div>
                  </div>

                  <div class="col-md-12">
                    <div class="text">Email Donatur</div>
                  </div>
                  <div
                    class="col-md-12"
                    v-if="statusData.emailDonatur !== null"
                  >
                    <div>{{ statusData.emailDonatur }}</div>
                  </div>

                  <div class="col-md-12">
                    <div class="text">Telepon Donatur</div>
                  </div>
                  <div class="col-md-12">
                    <div>{{ statusData.telpDonatur }}</div>
                  </div>

                  <div class="col-md-12">
                    <div class="text">Nominal</div>
                  </div>
                  <div class="col-md-6">
                    <div>
                      Rp.
                      {{
                        statusData.amount | numeral('0,0') | rupiah
                      }}
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="text">Status Pembayaran</div>
                  </div>
                  <div class="col-md-6">
                    <div
                      class="number"
                      :class="
                        statusData.status === 'unverified'
                          ? 'red'
                          : 'green'
                      "
                    >
                      {{ statusData.status }}
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="text">Metode Pembayaran</div>
                  </div>
                  <div class="col-md-6">
                    <div>{{ statusData.namaPembayaran }}</div>
                  </div>
                </div>
              </div>

              <div class="mt-3">
                <router-link to="/" class="btn btn-cta btn-full">
                  Kembali Ke Beranda
                </router-link>
              </div>
            </form>

            <div class="spacer"></div>
            <div class="spacer"></div>
          </div>
        </div>
      </div>
    </section>
  </Layout>
</template>

<script>
import Layout from '../views/layouts/Index.vue';
import axiosmasjid from '../utils/apimasjid';
// import axios from '../utils/api';
import { mapState, mapActions } from 'vuex';

export default {
  components: { Layout },
  name: 'danai',
  data() {
    return {
      data: [],
      submitStatus: false,
      novirtual: 'XXXXXX',
      dataPayment: '',
      statusData: '',
      isLoading: false,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.fetchDetail();
    window.history.forward(1);
    this.initialPaymentResponse();
  },
  created() {
    window.addEventListener('popstate', this.popstateEventAction);
  },
  computed: {
    ...mapState('transactions', [
      'programId',
      'paymentId',
      'paymentTitle',
      'paymentImage',
      'programTitle',
      'nominalDonasi',
      'userData',
      'paymentResponse',
    ]),
  },
  methods: {
    initialPaymentResponse() {
      const { data } = this.paymentResponse;
      // console.log(data);
      this.dataPayment = data;
      this.novirtual = data.no_va || 'XXXXX';
    },
    ...mapActions('transactions', ['setPaymentResponse']),
    async fetchDetail() {
      const { data } = this.paymentResponse;

      // console.log(data.trxid);
      this.isLoading = true;

      const cekStatus = await axiosmasjid.get(
        `/cektransaksi?no_transaksi=${data.trxid}`
      );
      this.isLoading = false;

      // console.log(cekStatus);

      this.statusData = cekStatus.data.data;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'scss/payment-after-action';

.text {
  font-weight: bold;
  font-size: 12px !important;
}

.red {
  color: rgb(189, 27, 27);
}

.green {
  color: rgb(13, 172, 13);
}

.mohontunggu {
  color: #fff;
  text-align: center;
  position: relative;
  top: 40%;

  .mohontunggu-text {
    font-size: 11px;
    margin: 0px;
    padding: 0px;
    font-weight: bold;
  }

  .diproses-text {
    font-size: 15px;
    margin: 0px;
    padding: 0px;
    font-weight: bold;
  }
}
</style>
